function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from "react";
import DataClientContext from "./config/DataClientContext";
import DataConfigContext from "./config/DataConfigContext";
import createGraphQlDataClient from "./config/createGraphQlDataClient";
import RawFetchCache from "./fetch/RawFetchCache";
import useObservabilityFns from "../shared/observability/useObservabilityFns";
function DataClientProvider({ children, config }) {
    const rawFetchCache = useMemo(()=>new RawFetchCache(), []);
    const observabilityFns = useObservabilityFns();
    const { graphql: graphQlConfig, fetch: fetchFunction } = config;
    const graphQlDataClient = useMemo(()=>createGraphQlDataClient(graphQlConfig, fetchFunction, observabilityFns), [
        graphQlConfig,
        fetchFunction,
        observabilityFns
    ]);
    const dataClient = useMemo(()=>({
            graphQlDataClient,
            fetchFunction,
            rawFetchCache
        }), [
        graphQlDataClient,
        fetchFunction,
        rawFetchCache
    ]);
    return /*#__PURE__*/ _jsx(DataClientContext.Provider, {
        value: dataClient,
        children: children
    });
}
export default function DataRevampLayer({ children, config, fetchFromOldProvider }) {
    const normalizedFetch = fetchFromOldProvider;
    // This ensures that the revamped provider is also getting the fetch version with
    // normalized headers
    const configWithFetch = useMemo(()=>{
        if (typeof config === 'undefined') {
            return undefined;
        }
        return _object_spread_props(_object_spread({}, config), {
            fetch: normalizedFetch || globalThis.fetch
        });
    }, [
        config,
        normalizedFetch
    ]);
    if (typeof configWithFetch === 'undefined') {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ _jsx(DataConfigContext.Provider, {
        value: configWithFetch,
        children: /*#__PURE__*/ _jsx(DataClientProvider, {
            config: configWithFetch,
            children: children
        })
    });
}

//# sourceMappingURL=DataRevampLayer.js.map